"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECONDS_IN_A_MINUTE = exports.SECONDS_IN_AN_HOUR = exports.SECONDS_IN_A_WEEK = exports.SECONDS_IN_A_DAY = void 0;
exports.SECONDS_IN_A_DAY = 86400;
exports.SECONDS_IN_A_WEEK = 604800;
exports.SECONDS_IN_AN_HOUR = 3600;
exports.SECONDS_IN_A_MINUTE = 60;
